import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RouteConfig } from '@app/routing/RenderRoutes'

import { PlatformTypeShort } from '@model/PlatformTypeEnum'

import { Platforms } from './Platforms'
import { PlatformsDownloadMT4Page, PlatformsDownloadMT5Page } from './PlatformsDownloadPage'
import { PlatformsLearnMorePage, TMTVideos } from './PlatformsLearnMorePage'
import { PlatformsTradingViewPage } from './PlatformsTradingViewPage'

export const usePlatformRoutes = (): RouteConfig[] => {
  const { t } = useTranslation()

  return useMemo(
    (): RouteConfig[] => [
      {
        path: 'platforms',
        outlet: <Platforms />,
        meta: { breadcrumbLabel: t('Platforms') },
        children: [
          {
            path: '',
            element: <div />,
          },
          {
            path: PlatformTypeShort.TickmillTrader,
            outlet: <PlatformsLearnMorePage />,
            meta: { breadcrumbLabel: t('Sign up.Tickmill Trader') },
            children: [
              {
                path: ':deviceType',
                element: <TMTVideos />,
              },
            ],
          },
          {
            path: PlatformTypeShort.TradingView,
            element: <PlatformsTradingViewPage />,
            meta: { breadcrumbLabel: t('TradingView') },
          },
          {
            path: PlatformTypeShort.MT4,
            element: <PlatformsDownloadMT4Page />,
            meta: { breadcrumbLabel: t('MT4') },
          },
          {
            path: PlatformTypeShort.MT5,
            element: <PlatformsDownloadMT5Page />,
            meta: { breadcrumbLabel: t('MT5') },
          },
        ],
      },
    ],
    [t]
  )
}
